module.exports = __webpack_public_path__ + "img/resent-fax-new.51469407.svg";